import React, { useState } from 'react'
import { QuestionBankEditView } from '@components/teachV2/QuestionBankDetail';
import { useLocation } from 'react-router-dom';

const QuestionBankEdit = () => {
  const location = useLocation();
  const [dataQuestionDetail, setDataQuestionDetail] = useState(JSON.parse(location?.state?.question))

  return (
    <div className="wrapper -teachV2HomePage pb-0">
      <QuestionBankEditView 
        dataQuestionDetail={dataQuestionDetail}
        setDataQuestionDetail={setDataQuestionDetail}
        type={location?.state?.type}
        path={location?.state?.path}
        permission={location?.state?.permission}
      />
    </div>
  )
}

export default QuestionBankEdit
